export default __webpack_public_path__ + "static/media/additional-resources-bg.d26f9dda.png";